export function BrandMark() {
  return (
    <svg
      className="brand-mark"
      viewBox="0 0 415 253"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M250.69 251.02L52.21 252.28L0 154.76L63.8 154.36L88.49 199.16L277.33 197.97L198.48 53.09L125.47 53.55L95.8301 0.880005L234.01 0L316.65 151.47L250.69 251.02Z"
        fill="currentColor"
      />
      <path
        d="M75.5901 54.29L100.5 100.17L173.07 98.85L201.25 152.63L63.8 154.36L10.29 54.7001L75.5901 54.29Z"
        fill="currentColor"
      />
      <path
        d="M314.15 99.6598L314.73 99.6198C321.77 89.1598 329.11 78.6797 336.46 68.4797L360.86 34.2998L414.02 34.7598L340.15 131.63L406.21 245.68H347.81L325.54 197.52C319.92 187.69 313.95 177.03 308.95 167.72L308.38 167.76C301.09 178.81 293.76 189.29 285.87 200.09L251.49 252.12L197.76 251.94L285.39 137.87"
        fill="currentColor"
      />
    </svg>
  );
}
